// shipping-protection.js

(function () {
  if (typeof window.fetch !== 'function') return;

  // === CONFIG ===

  // Handle of the TAG Shipping Protection product
  const PRODUCT_HANDLE = 'tag-shipping-protection';

  // Tier config. Thresholds are in CENTS.
  // priceCents should match the price of each variant in Shopify.
  // ⚠️ UPDATE priceCents values to match your actual variant prices.
  const TIERS = [
    {
      maxSubtotal: 10000,          // <= $100
      variantId: 48098711011543,   // Orders up to $100
      priceCents: 999              // e.g. $9.99
    },
    {
      maxSubtotal: 25000,          // <= $250
      variantId: 48098711044311,   // Orders $100–$250
      priceCents: 1499              // e.g. $14.99
    },
    {
      maxSubtotal: 50000,          // <= $500
      variantId: 48098711077079,   // Orders $250–$500
      priceCents: 1999              // e.g. $19.99
    },
    {
      maxSubtotal: Number.MAX_SAFE_INTEGER, // > $500
      variantId: 48098711109847,            // Orders over $500
      priceCents: 2499             // e.g. $24.99
    }
  ];

  // If true, we auto-add protection once per session unless user opts out
  const AUTO_ADD_ONCE = false;

  // SessionStorage keys
  const AUTO_ADDED_KEY = 'sp_auto_added';
  const OPTED_OUT_KEY = 'sp_opted_out';

  // DOM IDs from your snippet
  const blockId = 'shipping-protection-block';
  const toggleId = 'shipping-protection-toggle';
  const priceSpanId = 'shipping-protection-price';

  // === HELPERS ===

  function findTierForSubtotal(subtotal) {
    return TIERS.find(t => subtotal <= t.maxSubtotal) || null;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(res => res.json());
  }

  function getProtectionItems(cart) {
    return cart.items.filter(item => item.handle === PRODUCT_HANDLE);
  }

  // 🔴 UI: sets checkbox + "Protect your order for $X.XX"
  function updateUI(cart, tier, enabled) {
    const block = document.getElementById(blockId);
    const toggle = document.getElementById(toggleId);
    const priceSpan = document.getElementById(priceSpanId);
    if (!block || !toggle || !priceSpan || !tier) return;

    toggle.checked = enabled;

    const priceCents = tier.priceCents;
    if (priceCents != null) {
      const priceFormatted = `$${(priceCents / 100).toFixed(2)}`;
      priceSpan.textContent = ` – Protect your order for ${priceFormatted}, uncheck to remove.`;
    } else {
      priceSpan.textContent = '';
    }
  }

  function removeProtectionItemsSequential(items, index) {
    if (!items || index >= items.length) return Promise.resolve();

    const item = items[index];

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: item.key,
        quantity: 0
      })
    }).then(function () {
      return removeProtectionItemsSequential(items, index + 1);
    });
  }

  function addProtectionVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });
  }

  /**
   * Main setter: enable or disable protection.
   * Ensures: at most ONE protection line, always correct tier.
   */
  function setProtection(enabled) {
    return fetchCart().then(function (cart) {
      const subtotal = cart.items_subtotal_price; // cents
      const tier = findTierForSubtotal(subtotal);
      if (!tier) return;

      const protectionItems = getProtectionItems(cart);
      const enabledCurrently = protectionItems.length > 0;
      const primary = protectionItems[0];

      // Disabling
      if (!enabled) {
        if (!enabledCurrently) return;

        // Remember user opted out
        window.sessionStorage.setItem(OPTED_OUT_KEY, '1');

        return removeProtectionItemsSequential(protectionItems, 0).then(function () {
          window.location.reload();
        });
      }

      // Enabling: clear opt-out flag
      window.sessionStorage.removeItem(OPTED_OUT_KEY);

      // Already correct + only one + qty 1 → nothing to do
      if (
        enabledCurrently &&
        protectionItems.length === 1 &&
        primary.variant_id === tier.variantId &&
        primary.quantity === 1
      ) {
        return;
      }

      // Remove existing items (if any), then add the correct one
      return removeProtectionItemsSequential(protectionItems, 0)
        .then(function () {
          return addProtectionVariant(tier.variantId);
        })
        .then(function () {
          window.location.reload();
        });
    });
  }

  /**
   * Recalculate correct tier & clean up cart if needed.
   * Called on page load and after cart changes.
   */
  function recalcProtection() {
    return fetchCart().then(function (cart) {
      const subtotal = cart.items_subtotal_price;
      const tier = findTierForSubtotal(subtotal);
      if (!tier) return;

      const protectionItems = getProtectionItems(cart);
      const enabled = protectionItems.length > 0;
      const primary = protectionItems[0];

      const block = document.getElementById(blockId);
      if (!block) return;

      // If protection is present but wrong (multiple / wrong variant / qty),
      // fix it by forcing enabled=true with current tier.
      if (
        enabled &&
        (
          protectionItems.length > 1 ||
          primary.variant_id !== tier.variantId ||
          primary.quantity !== 1
        )
      ) {
        return setProtection(true);
      }

      // Update UI label + checkbox
      updateUI(cart, tier, enabled);

      // Auto-add once per session (if enabled & not opted out)
      if (
        AUTO_ADD_ONCE &&
        !enabled &&
        !window.sessionStorage.getItem(AUTO_ADDED_KEY) &&
        !window.sessionStorage.getItem(OPTED_OUT_KEY)
      ) {
        window.sessionStorage.setItem(AUTO_ADDED_KEY, '1');
        return setProtection(true);
      }
    });
  }

  function attachToggleHandler() {
    const toggle = document.getElementById(toggleId);
    if (!toggle) return;

    toggle.addEventListener('change', function () {
      setProtection(toggle.checked);
    });
  }

  function attachCartChangeWatcher() {
    // Watch for quantity changes on the cart page
    document.addEventListener('change', function (e) {
      if (e.target.matches('input[name^="updates"]')) {
        setTimeout(recalcProtection, 800);
      }
    });

    // If your theme triggers custom events on cart updates, hook them as well:
    document.addEventListener('cart:refresh', function () {
      recalcProtection();
    });
  }

  function attachCheckoutWarning() {
    // Warn when heading to checkout without protection
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('button[name="checkout"], form[action="/checkout"] [type="submit"]');
      if (!btn) return;

      fetchCart().then(function (cart) {
        const protectionItems = getProtectionItems(cart);
        const hasProtection = protectionItems.length > 0;

        if (!hasProtection && !window.sessionStorage.getItem('sp_warning_seen')) {
          e.preventDefault();
          const answer = window.confirm(
            'Your order is not protected against loss or damage in transit. Add TAG Shipping Protection before checkout?'
          );
          window.sessionStorage.setItem('sp_warning_seen', '1');

          if (answer) {
            setProtection(true); // will reload page with protection added
          } else {
            const form = btn.form;
            if (form) form.submit();
          }
        }
      });
    }, true);
  }

  function init() {
    const block = document.getElementById(blockId);
    if (!block) return;

    recalcProtection();
    attachToggleHandler();
    attachCartChangeWatcher();
    attachCheckoutWarning();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
